import { InjectionToken } from '@angular/core';

/**
 * Services that hold session-scoped in-memory state (rxResource caches, UI list
 * state, loaders, etc.) should implement this and register via SESSION_RESETTABLE.
 * AuthService.clearSession() invokes every registered resetter.
 */
export interface SessionResettable {
  resetSessionState(): void;
}

export const SESSION_RESETTABLE = new InjectionToken<SessionResettable>(
  'SESSION_RESETTABLE',
);
